export const toPick = [
  'value',
  'valueOther',
  'onChange',
  'onChangeOther',
  'readOnly',
  'lists',
  'cache',
  'lookups',
  'searches',
  'errored',
  'warning',
  'validationResult',
  'onAction',
  'psfs',
  'formId'
] as const;
